module.exports = __webpack_public_path__ + "static/media/ogl3.png.5c884d54.jpg";